import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { SWEEP_PARTICIPANT_BASE_PATH } from '../../../../../../../../../features/sweeps/clearing/participant/sweep-participant-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-participants-list',
        label: 'Sweeps',
        to: SWEEP_PARTICIPANT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
